/**
 * Display formatting for sentences shown to players.
 *
 * The codebook translations are authored without leading capitals or trailing
 * punctuation in some places. When we surface the "official" sentence on the
 * reveal screens we present it as a proper sentence: capitalised first letter
 * and a terminal full stop (unless it already ends in . ! ? or …).
 *
 * Capitalisation via toLocaleUpperCase handles accented first letters
 * (e.g. French "à", "é") correctly across the languages we serve.
 */
export function formatSentence(s: string | undefined | null): string {
  const t = (s ?? "").trim();
  if (!t) return "";
  const first = t.charAt(0).toLocaleUpperCase() + t.slice(1);
  return /[.!?…]$/.test(first) ? first : `${first}.`;
}
